import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logoNew.svg'


const _withScopeId = n => (_pushScopeId("data-v-321f8904"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media_hero mediabuying-section" }
const _hoisted_2 = { class: "media_hero__wrapper container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "media_hero__logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = { class: "media_hero__content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "media_hero__title" }, "Masons Traffic", -1))
const _hoisted_6 = { class: "media_hero__subTitle" }
const _hoisted_7 = { class: "media_hero__top" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "media_hero__img" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "36",
    height: "37",
    viewBox: "0 0 36 37",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "18",
      cy: "18.5",
      r: "10",
      fill: "#EDB94A"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "18",
      cy: "18.5",
      r: "14",
      stroke: "#EDB94A",
      "stroke-opacity": "0.2",
      "stroke-width": "8"
    })
  ])
], -1))
const _hoisted_9 = { class: "media_hero__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("h2", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('mediaBuying.hero.title')), 1),
          _hoisted_8
        ]),
        _createElementVNode("p", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('mediaBuying.hero.subtitle')), 1)
        ]),
        _createVNode(_component_Button, {
          outlined: "",
          type: "button",
          onClick: _ctx.onRequest,
          class: "media__button media__hero_btn",
          text: this.$t('btn.join')
        }, null, 8, ["onClick", "text"])
      ])
    ])
  ]))
}